import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	title: {
		id: 'invite-on-third-party-link.invite-error-flag.title',
		defaultMessage: 'Something went wrong',
		description: 'Title shown in the invite error notification flag.',
	},
	description: {
		id: 'invite-on-third-party-link.invite-error-flag.description',
		defaultMessage:
			'Try inviting your teammates again. If the problem persists, contact support.',
		description:
			'Description informing the user that invites were not successfully sent.',
	},
	action: {
		id: 'invite-on-third-party-link.invite-error-flag.action',
		defaultMessage: 'Contact support',
		description:
			'Action button label to contact support for invite errors.',
	},
});
